// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bEIK","image":"Header_image__3EXdM","name":"Header_name__3PLHQ","info":"Header_info___LCgo","infoRow":"Header_infoRow__DBXv6"};